import { FormikValues, useFormikContext } from "formik";
import React from "react";
import OpenLinkInNewTab from "shared/form/core/link";
import FormGroup from "shared/form/fields/formGroup";
import FormLabel from "shared/form/fields/formLabel";
import FormTextField from "shared/form/fields/textField";
import { useDynamicFormRenderer } from "shared/form/renderer/context/dynamicFormRendererContext";
import FieldIdentifier from "shared/form/renderer/enums/FieldIdentifier";
import DynamicFieldConfigType from "shared/form/renderer/types/DynamicFieldConfigType";
import { useCopies } from "shared/hooks/useCopies";
import DynamicFieldLabel from "../DynamicFieldLabel";

export default function OrganizationUrlComponent(props: DynamicFieldConfigType) {
  const copies = useCopies();
  const { isAdminOnly, isRegistrationOrganization } = useDynamicFormRenderer();
  // required to reset org url field when org is removed in reg
  // todo:rr check current behaviour with Prashant
  const resetOrgUrlRef = React.useRef<boolean>(false);
  // for special handling in approvals screen
  const [fieldDisabled, setFieldDisabled] = React.useState<boolean>(false);
  // we need to do custom handling for org url field as we don't want to allow user to change the org URL
  //     hence we need to show it disabled if both org id and org URL are present
  const { setFieldValue, values } = useFormikContext<FormikValues>();

  React.useEffect(() => {
    if (!values[FieldIdentifier.ORGANIZATION_ID] && values[props.schemaObj.id]) {
      if (isAdminOnly) {
        setFieldValue(props.schemaObj.id, "");
        setFieldDisabled(true);
      } else if (resetOrgUrlRef.current && !isRegistrationOrganization) {
        setFieldValue(props.schemaObj.id, "");
        resetOrgUrlRef.current = false;
      }
    } else if (values[FieldIdentifier.ORGANIZATION_ID] && !isAdminOnly) {
      resetOrgUrlRef.current = true;
    }
  }, [copies, isAdminOnly, isRegistrationOrganization, props.schemaObj.id, setFieldValue, values]);

  if (!isRegistrationOrganization && values[FieldIdentifier.ORGANIZATION_ID] && values[props.schemaObj.id]) {
    return (
      <FormGroup fullWidth={props.schemaObj.fullWidthView} indented={props.schemaObj.indented}>
        <FormLabel label={<DynamicFieldLabel schemaObj={props.schemaObj} />} required={props.schemaObj.mandatory} />
        <OpenLinkInNewTab url={values[props.schemaObj.id]} title={values[props.schemaObj.id]} />
      </FormGroup>
    );
  }

  return (
    <FormTextField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      disabled={props.schemaObj.disabled || fieldDisabled}
      required={props.schemaObj.mandatory}
      placeholder={props.schemaObj.placeholderLabel}
      validate={props.validationFn}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
    />
  );
}
